export const getAccountPath = (email: string) => `/iam/accounts/email/${email}`;
